<template>
  <div>
    <Head> </Head>
    <div class="index">
      <Leftside style="flex:1" :isActive='isActive' @leftnav='nav'></Leftside>
      <div class="content" style="flex:5">
          <!-- 导航标签 -->
          <mainnav :navActive='navActive'></mainnav>
          <!-- 轮播 -->
          <!--<el-carousel :interval="5000" arrow="always">
            <el-carousel-item v-for="item in 2" :key="item" :autoplay="false">
              <img src="../assets/nav_1.png" style="width:100%;height:100%;margin: 20px 0 25px;">
            </el-carousel-item>
          </el-carousel>-->
          

          <!-- 发现失信人 -->
          <Court></Court>


      </div>
    </div>
  </div>
</template>

<script>
import Head from '../common/head.vue'
import Leftside from '../common/leftside.vue'
import mainnav from '../common/main_nav.vue'
import Court from '../common/court.vue'
export default {
  name: 'court',
  data () {
    return {
      isActive:'0',
      navActive:'3',
      data:'1',
    }
  },
  mounted(){
    
    
  },
  methods:{
    step(data){
      this.data = data;
    },
    nav(data){
      // this.isActive = data;
      console.log(data);
    },
    tiaozhuan(url){
      this.$router.push({path:url})
    }


  },
  components:{
    Head,
    Leftside,
    mainnav,
    Court
  },
}
</script>
<style scoped>
.index{
  width:100vw;
  display:flex;
}
.index .content{
  padding: 3% 2%;
  background:#f1f5f8;
}
.index .content .content_nav{
  overflow:hidden;
  background:#ffffff;
}
.index .content .content_nav li{
  float:left;
  box-sizing: border-box;
  height:80px;
  line-height:75px;
  text-align:center;
  width:20%;
  cursor: pointer;
}
.index .content .content_nav li:hover span{
  color: #2fb8c2;
  display: inline-block;
  width:50%;
  border-bottom: 5px solid #2fb8c2;
}
.index .content .content_nav li span.nav_active{
  color: #2fb8c2;
  display: inline-block;
  width:50%;
  border-bottom: 5px solid #2fb8c2;
}



</style>



// WEBPACK FOOTER //
// src/page/court.vue